<template>
    <div class="content building">
        <p>经历多年的发展，建筑智能化系统已然成为现代建筑和园区的基本配置。10余年间，西安锦威的智能化项目遍布住宅、商业综合体、医院、博物馆、图书馆、工业厂房、洁净车间、生物安全实验室。西安锦威向客户提供设计、施工、调试、交付全过程交钥匙服务。
        </p>
        <p>
            <img src="../../../../../assets/img/product/building/building_jiagou_2560.png" v-if="screenWidth == 2560"></img>
            <img src="../../../../../assets/img/product/building/building_jiagou_1080.png" v-else></img>
        </p>

        <br></br>
        <p>西安锦威注重施工细节，努力将每个项目打造成精品工程。</p>
        <p><img src="../../../../../assets/img/product/building/building_shigongxijie.png"></img></p>

        <br></br>
        <p>建筑智能化涵盖的信息设施、安全管理设施以及建筑设备管理设施等，都与用户体验紧密相关。随着行业不断发展，多系统数据集成、打破数据孤岛以及实现功能智慧化，已成为用户日益迫切的需求。</p>
        <p style="text-align: center;"><img src="../../../../../assets/img/product/building/building_zhinenghua.png" style="width:80%;"></img></p>

        <br></br>
        <p>在此背景下，西安锦威电子科技有限公司高度重视创新与突破。企业自主研发的建筑智能化集成平台，能够对所有智能化子系统进行集成，将繁杂的数据资源转化为有用信息，从而实现信息可视化、环境监测与优化控制、碳排放监测和能耗管理、建筑设施全生命周期管理以及AI安防系统的精准化升级等多种创新型功能应用。</p>
        <p style="text-align: center;"><img src="../../../../../assets/img/product/building/building_pingtai.png" style="width:60%;"></img></p>

        <br></br>
        <p>通过这些创新型功能应用，西安锦威电子科技有限公司的建筑智能化集成平台为用户带来了显著的效益提升。在信息可视化方面，用户可以直观地了解建筑内各系统的运行状态，及时发现潜在问题并做出决策。环境监测与优化控制功能则可以根据实时数据调整建筑内的温度、湿度、光照等环境参数，提高用户的舒适度同时降低能源消耗。碳排放监测和能耗管理功能有助于企业和建筑管理者更好地了解能源使用情况，制定节能减排策略，响应国家的环保政策。建筑设施全生命周期管理可以对建筑内的设备进行实时监控和维护，延长设备使用寿命，降低运营成本。AI安防系统的精准化升级则大大提高了建筑的安全性，有效预防和应对各类安全事件。</p>
        <p style="text-align: center;"><img src="../../../../../assets/img/product/building/building_jicheng.png" style="width:70%;"></img></p>

        <br></br>
        <p>未来，西安锦威电子科技有限公司将继续紧跟市场需求和技术发展趋势，不断对建筑智能化集成平台进行优化和升级。一方面，加强与其他相关领域的技术融合，如物联网、大数据、人工智能等，进一步提升平台的智能化水平和功能多样性。另一方面，拓展平台的应用场景，不仅局限于商业建筑，还将向住宅、公共设施等领域延伸，为更多用户提供优质的建筑智能化解决方案。同时，企业也将注重人才培养和团队建设，吸引更多优秀的技术和管理人才加入，为企业的持续创新和发展提供坚实的保障。在不断的探索和实践中，推动整个行业向更高水平发展。</p>
    </div>
</template>

<script>
export default{
    data(){
        return {
            screenWidth:1080
        }
    },
    mounted(){
        this.screenWidth = window.innerWidth;
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/product.less';
</style>